import React from 'react'

function Private() {
    return (
        <div className='private_cont'>
            <span className='private_pre'>
                <h3>총 칙</h3>
                {`
                    
1. "개인정보"라 함은 생존하고 있는 개인에 관한 정보로서 성명ㆍ주민등록번호ㆍ휴대전화번호 등에 의하여 당해 개인을 알아볼 수 있는 부호ㆍ문자ㆍ음성ㆍ음향ㆍ영상 및 생체특성 등에 관한 정보(당해 정보만으로는 특정 개인을 알아볼 수 없는 경우에도 다른 정보와 용이하게 결합하여 알아볼 수 있는 것을 포함합니다)를 말합니다.

2. “개인위치정보”라 함은 특정 개인의 위치정보(위치정보만으로는 특정 개인의 위치를 알 수 없는 경우에도 다른 정보와 용이하게 결합하여 특정 개인의 위치를 알 수 있는 것을 포함합니다)를 말합니다.

3. (주)이케이시스는 고객의 개인정보보호를 매우 중요시하며, 『정보통신망이용촉진및정보보호등에관한법률』의 개인정보보호규정을 준수하고 있습니다. ㈜이케이시스는 개인정보보호방침을 통하여 고객이 제공하는 개인정보의 수집목적 및 이용목적, 개인정보보호를 위해 (주)이케이시스가 취하고 있는 조치 등을 알려드립니다.

4. (주)이케이시스는 개인정보보호방침을 홈페이지 첫 화면에 공개 또는 영업장에 비치함으로써 고객께서 언제나 용이하게 보실 수 있도록 조치하고 있습니다.

5. (주)이케이시스는 개인정보보호방침의 지속적인 개선을 위하여 개인정보보호방침을 개정하는데 필요한 절차를 정하고 있습니다. 그리고 개인정보보호방침을 개정하는 경우 버전번호 등을 부여하여 개정된 사항을 고객이 쉽게 알아볼 수 있도록 하고 있습니다.

`}
                <span className='sub'>개인위치정보의 수집범위</span>{`
                
1. ㈜이케이시스는 개인정보 및 개인위치정보 수집 시 관련 법규에 따라 가입신청서 또는 이용약관에 그 수집범위 및 목적을 사전 고지합니다.

2. ㈜이케이시스는 인종 및 민족, 사상 및 신조, 출신지 및 본적지, 정치적 성향 및 범죄기록, 건강상태 및 성생활 등 고객의 기본적 인권을 현저하게 침해할 우려가 있는 개인정보를 수집하지 않습니다.

`}
                <span className='sub'>개인위치정보의 처리</span>{`
                
1. 개인위치정보 수집/이용/제공사실 확인자료의 보유근거 및 보유기간

가. ㈜이케이시스는 위치정보법 제 16조 제2항에 근거하여 다른 사업자 또는 이용 고객과 요금정산 및 민원처리를 위해 위치정보 수집, 이용, 제공 사실확인 자료를 위치정보시스템에 자동으로 기록하는 방법으로 180일간 보존합니다.

나. ㈜이케이시스는 이용자 또는 개인위치정보주체가 개인위치정보 수집/이용/제공 동의의 전부 또는 일부를 철회한 경우에는 지체없이 수집된 개인위치정보 및 위치정보 수집/이용 및 제공사실 확인자료(동의의 일부를 철회하는 경우에는 철회하는 부분의 개인위치정보 및 위치정보 이용 및 제공사실 확인자료에 한합니다)를 파기합니다. 단, 관련 법령의 규정에 의하여 보존할 필요성이 있는 경우에는 해당 법령에서 정한 바에 따라 이를 보존합니다. 이용자는 개인위치정보 주체로부터 위 동의의 철회 요청을 받는 경우 지체없이 서비스 제공자에게 이를 통보하여야 합니다.

2. 개인위치정보의 처리목적 및 보유기간

㈜이케이시스는 위치정보 수집/이용/제공사실 확인자료를 개인고객에게 서비스를 제공하는 기간동안 보존합니다. 단, 개인위치정보 수집/이용/제공목적을 달성한 때에는 개인위치정보를 파기하고, 고객의 서비스 이용불만에 대한 응대를 고려하여 보유 기간은 최대 180일로 하며, 해지고객의 경우 최대 15일로 합니다.

3. 개인위치정보 제 3자 제공 시 즉시 통보

가. ㈜이케이시스는 개인위치정보주체의 동의 없이 당해 개인위치정보주체의 개인위치정보를 제 3자에게 제공하지 아니하며, 제 3자 제공 서비스를 제공하는 경우에는 제공받는 자 및 제공목적을 사전에 개인위치정보주체에게 고지하고 동의를 받습니다.

나. ㈜이케이시스는 개인위치정보를 개인위치정보주체가 지정하는 제 3자에게 제공하는 경우에는 개인위치정보를 수집한 당해 통신단말장치로 매회 개인위치정보주체에게 제공받는 자, 제공일시 및 제공목적을 즉시 통보합니다. 다만, 아래에 해당하는 경우에는 개인위치정보주체가 미리 특정하여 지정한 통신단말장치 또는 전자우편주소 등으로 통보합니다.
① 개인위치정보를 수집한 당해 통신단말장치가 문자, 음성 또는 영상의 수신기능을 갖추지 아니한 경우
② 개인위치정보주체가 개인위치정보를 수집한 당해 통신단말장치 외의 통신단말장치 또는 전자우편주소 등으로 통보할 것을 미리 요청한 경우

4. 개인위치정보 파기 절차 및 방법

㈜이케이시스는 고객의 개인위치정보의 수집/이용/제공 목적을 달성한 때에는 위치정보법 제16조 제2항의 규정에 의하여 기록 보존하여야 하는 위치정보 수집/이용/제공사실 확인자료 외의 당해 개인위치정보를 지체없이 파기합니다. 전자적 파일 형태는 재생이 불가능한 기술적인 방법으로 파기하며, 출력물 등은 분쇄하거나 소각하는 방식으로 파기합니다.

5. 8세 이하 아동 등의 보호의무자의 권리‧의무 및 행사방법

가. ㈜이케이시스는 아래의 경우에 해당하는 자(이하 “8세 이하의 아동 등”)의 보호의무자가 8세 이하 아동 등의 생명 또는 신체보호를 위하여 개인위치정보를 이용하거나 제공하는 데 동의했을 때에는 본인의 동의가 있는 것으로 봅니다.
    - 8세 이하의 아동
    - 피성년후견인
    - 장애인복지법 제2조제2항제2호에서 규정하는 정신적 장애를 가진 자로서 장애인고용촉진 및 직업재활법 제2조제2호에서 규정하는 중증장애인에 해당하는 자(장애인복지법 제29조의 규정에 따라 장애인등록을 한 자에 한한다)

나. 8세 이하 아동 등의 생명 또는 신체 보호를 위하여 개인위치정보를 이용하거나 제공하는 데 동의하고자 하는 보호의무자는 보호의무자임을 증명하는 서면 동의서를 첨부하여 ㈜이케이시스에게 제출하여야 합니다.

다. 8세 이하 아동 등의 개인위치정보를 이용하거나 제공하는 데 동의하는 보호의무자는 개인위치정보주체 권리의 전부를 행사할 수 있습니다.

`}
                <span className='sub'>개인정보 수집에 대한 동의</span>{`

1. (주)이케이시스는 고객께서 서비스 이용 신청서, 명의변경 계약서 또는 부가서비스 이용 신청서에 서명함으로 (주)이케이시스의 홈페이지에 공개된 또는 지점 및 대리점에 비치된 개인정보보호방침 및 이용약관에 따른 개인정보 및 개인위치정보 수집에 대해 동의한 것으로 봅니다.

2. (주)이케이시스는 위치정보의 보호 및 이용 등에 관한 법률 26조의 규정에 의한 8세 이하의 아동, 금치산자, 중증정신지체장애인(이하 8세이하 아동 등)등의 법정대리인, 보호의무자가 8세 이하의 아동 등의 생명 또는 신체의 보호를 위하여 8세 이하의 아동 등의 개인위치정보의 수집ㆍ이용 또는 제공에 동의하는 경우에는 본인의 동의가 있는 것으로 봅니다.

`}
                <span className='sub'>목적 외 사용 또는 제 3자에 대한 제공 및 공유</span>{`

1. (주)이케이시스는 고객의 개인정보를 가입신청서, 서비스이용약관 및 개인정보호방침의 「개인정보의 수집목적 및 이용목적」에서 고지한 범위 또는 서비스 이용약관에 명시한 범위 내에서 사용하며, 동 범위를 넘어 이용하거나 제 3자에게 제공하지 않습니다. 특히, 다음의 경우에는 주의를 기울여 개인정보를 이용 및 제공할 것입니다.

    가. 제휴 관계보다 나은 서비스 제공을 위하여 고객의 개인정보를 제휴사에게 제공하거나 또는 제휴사와 공유할 수 있습니다. 개인정보를 제공하거나 공유할 경우에는 사전에 고객에게 제휴사가 누구인지, 제공 또는 공유되는 개인정보 항목이 무엇인지, 왜 그러한 개인정보가 제공되거나 공유되어야 하는지, 그리고 언제까지 어떻게 보호, 관리되는지에 대해 개별적으로 서면 또는 전자우편 등을 통해 고지하여 동의를 구하는 절차를 거치게 되며, 고객이 동의하지 않는 경우에는 제휴사에 제공하거나 공유하지 않습니다. 제휴 관계에 변화가 있거나 제휴 관계가 종결될 때도 같은 절차에 의하여 고지하거나 동의를 구합니다. 단, 개인위치정보는 개인정보주체가 사전에 지정한 조회자 외 사전 동의를 득하지 않고 제휴사나 제3 자에게 제공하지 않습니다.

    나. 매각, 인수합병 등 영업의 전부 또는 일부를 양도하거나 합병, 상속 등으로 서비스 제공자의 권리, 의무를 이전 승계하는 경우 개인정보보호 관련 고객의 권리를 보장하기 위하여 반드시 그 사실을 고객에게 통지합니다.

2. (주)이케이시스는 고객의 개인정보 수집 시 고객에게 고지한 범위 또는 서비스 이용약관에 명시한 범위를 넘어 이용하거나 제 3자에게 제공하지 않습니다. 다만, 고객의 동의가 있거나 다음 각호의 1에 해당하는 경우에는 예외로 합니다.

    가. 서비스 제공에 따른 요금 정산을 위하여 필요한 경우 단, 요금 정산을 위해서는 위치정보 수집, 이용, 제공사실 확인자료를 이용하는 것으로 제한되며 개인위치정보 자체를 이용 또는 제공하지 않습니다.

    나. 통계작성, 학술연구 또는 시장조사를 위하여 필요한 경우로서 특정 개인을 알아볼 수 없는 형태로 가공하여 연구단체, 설문조사, 리서치 기관, 광고주, 제휴, 협력사 등 제 3자에게 제공하는 경우

    다. 통신비밀보호법, 국세기본법, 정보통신망이용촉진및정보보호에관한법률, 금융실명거래및비밀보장에관한법률, 신용정보의이용및보호에관한법률, 전기통신기본법, 전기통신사업법, 지방세법, 소비자보호법, 한국은행법, 형사소송법 등 법률에 특별한 규정이 있는 경우 단, '법률에 특별한 규정이 있는 경우'로 행정목적이나 수사목적으로 행정관청 또는 수사기관이 요구해 온 경우라도 무조건 고객의 개인정보를 제공하지 않으며, 법률에 규정된 바에 따라 영장 또는 기관장의 직인이 날인된 서면에 의한 경우 등 적법한 절차에 따라 제공합니다.

    라. 재난및안전관리기본법 제3조제7항의 규정에 의한 긴급구조기관이 급박한 위험으로부터 생명, 신체를 보호하기 위하여 개인위치정보주체, 개인위치정보주체의 배우자 또는 직계 존,비속의 긴급구조요청이 있는 경우 긴급구조 상황 여부를 판단하여 개인위치정보의 제공을 요청한 경우. 단, (주)이케이시스는 개인위치정보를 긴급구조기관에 제공하는 경우 개인위치정보의 제공 사실을 당해 개인위치정보주체에게 즉시 통보합니다.

3. (주)이케이시스는 고객의 개인위치정보를 개인위치정보주체의 동의 없이 제 3자에게 제공하지 않으며 고객이 지정하는 제 3자에게 개인위치정보를 제공하는 경우에도 매회 개인위치정보를 제공받은 제 3자, 제공일시, 제공목적을 고객이 사전에 지정한 방법으로 통보합니다.

`}
                <span className='sub'>고지, 명시, 공개, 공지 또는 통지방법</span>{`

1. (주)이케이시스는 개인정보 수집 시 고지한 범위 또는 서비스 이용약관, 본 개인정보보호방침에 명시한 범위를 넘어 고객의 개인정보를 이용하거나 제 3자에게 제공하기 위해 고객의 동의를 얻고자 하는 때에는 미리 고객에게 개별적으로 서면, 전자우편, 전화 등으로 해당 사항을 고지합니다.

2. 타인에게 고객의 개인정보의 수집, 취급, 관리 등을 위탁하는 경우에는 가입신청서, 서비스이용약관 등을 통하여 미리 그 사실을 고객에게 고지합니다.

3. (주)이케이시스는 영업의 전부 또는 일부를 양도하거나 합병, 상속 등으로 그 권리, 의무를 이전하는 경우 서면, 전자우편 등을 통하여 고객에게 개별적으로 통지함과 동시에 홈페이지 첫 화면에서 식별할 수 있도록 표기하여 30일 동안 그 사실을 공지합니다. 다만, 서면, 전자우편 기타의 방법에 의한 통지는 과실 없이 고객의 연락처를 알지 못하거나 천재, 지변 기타 통지할 수 없는 정당한 이유가 있는 경우에는 2곳 이상의 중앙일간지(고객의 대부분이 특정 지역에 거주하는 경우에는 그 지역을 보급구역으로 하는 일간지로 할 수 있습니다)에 1회 이상 공고하는 것으로 갈음합니다.

4. 만 14세 미만 아동의 개인정보 수집, 이용 또는 제 3자에게 제공하기 위하여 법정대리인의 동의를 받고자 하는 경우에는 전화, 팩스. 우편, 아동으로 하여금 통지내용을 법정대리인에게 제출하게 하는 방법, 법정대리인에게 전자우편을 보내면서 홈페이지의 개인정보보호방침을 볼 수 있도록 연결(하이퍼링크)시키는 방법 또는 기타 법정대리인에게 고지 내용이 도달할 수 있는 합리적인 방법을 통하여 고지사항을 법정대리인에게 고지합니다.

`}
                <span className='sub'>개인정보의 열람, 증명 또는 정정</span>{`

1. (주)이케이시스는 고객이 개인정보 및 개인위치정보 수집, 이용, 제공사실 확인자료에 대한 열람, 증명 또는 정정을 요구하는 경우에는 고객의 요구에 성실하게 대응하고, 해당 개인정보에 오류가 있거나 보존기간을 경과한 것이 판명되는 등 정정, 삭제를 할 필요가 있다고 인정되는 경우에는 지체없이 정정, 삭제를 합니다. 단, 위치정보 수집ㆍ이용ㆍ제공사실 확인자료는 개인위치정보주체 본인 확인 절차 후 개인위치정보주체에게만 제공됩니다.

2. 고객은 (주)이케이시스는 또는 (주)이케이시스와 위탁업무계약을 맺은 지점에 방문하여 개인정보에 대한 열람, 증명을 요구할 수 있고, 고객이 제공한 개인정보를 보다 철저하게 보호하기 위하여 고객의 지점 방문 및 홈페이지 이외의 전화, 우편, FAX 등 기타의 신청 방법에 의하여 고객의 개인정보에 대한 열람, 증명을 제공하지 않습니다.

3. (주)이케이시스는 고객이 위탁업무계약을 맺은 지점, 대리점 및 고객센터에 방문하거나 전화 등을 이용하여 개인정보에 대한 정정을 요구하는 경우, 본인 여부를 확인하고 지체없이 필요한 조치를 취합니다. 또한 개인위치정보에 대한 정정 요구 시 (주)이케이시스는 정정이 완료되기 전까지 당해 개인위치정보를 이용 또는 제공하지 않습니다. 또한 잘못된 개인위치정보를 이미 제공한 경우에는 정정 처리결과를 제 3자에게 지체없이 통지하여 정정이 이루어지도록 조치하겠습니다.

4. 고객이 본인의 개인정보에 대한 열람, 증명을 요구하는 경우, 고객의 신분을 나타내는 주민등록증, 여권, 운전면허증 등의 신분증명서를 제시받아 본인 여부를 확인합니다.

5. 고객의 대리인이 방문하여 열람, 증명을 요구하는 경우에는 대리관계를 나타내는 위임장 및 명의 고객의 인감증명서와 대리인의 신분증명서 등의 증표를 제시받아 진정한 대리인 여부를 확인합니다.

6. 고객이 제 3자에 대한 개인정보 제공에 동의한 경우에도 오류 정정의 요구를 받은 경우에는 그 오류를 정정할 때까지 개인정보 제공을 중단하고, 잘못된 개인정보를 제 3자에게 이미 제공한 경우에는 제 3자 및 당사자에게 그 사실을 통지하여 필요한 조치를 취합니다.

7. (주)이케이시스는 개인정보의 전부 또는 일부에 대하여 열람, 증명 또는 정정을 거절할 정당한 이유가 있는 경우에는 고객에게 이를 통지하고 그 이유를 설명합니다.

`}
                <span className='sub'>개인정보 수집, 이용 또는 제공에 대한 동의철회(가입해지)</span>{`

1. (주)이케이시스는 개인정보의 전부 또는 일부에 대하여 열람, 증명 또는 정정을 거절할 정당한 이유가 있는 경우에는 고객에게 이를 통지하고 그 이유를 설명합니다.

2. 고객이 방문하여 개인정보의 수집, 이용 또는 제공에 대한 동의를 철회하는 경우에는 본인 여부를 확인하고 법령에 다르게 규정하고 있는 경우를 제외하고는 당해 개인정보를 파기하는 등 지체없이 필요한 조치를 취합니다.

3. 고객이 개인정보의 수집, 이용 또는 제공에 대한 동의를 철회하는 것은 고객이 서비스 이용 의사를 철회하는 것이므로 가입 해지를 요구하는 것입니다.

4. 법정대리인은 만 14세 미만 아동의 개인정보 수집, 이용 또는 제공에 대한 동의를 철회할 수 있으며, 만 14세 미만 아동이 제공한 개인정보에 대한 열람 또는 오류의 정정을 요구할 수 있습니다.

5. 개인위치정보주체는 언제든지 개인위치정보 수집, 이용 및 제공에 대한 동의의 전부 또는 일부에 대하여 철회할 수 있으며 일시적인 중지를 요구할 수 있습니다. 또한 등록되어 있는 자신의 정보를 조회하거나 수정 및 가입 해지를 요청할 수도 있습니다. 단, 위치기반서비스사업자는 개인위치정보주체의 동의서를 첨부하여 회사에 요청할 수 있습니다.

`}
                <span className='sub'>개인정보의 보관기간 및 이용기간</span>{`

1. 고객의 개인정보는 (주)이케이시스가 고객에게 서비스를 제공하는 기간 동안에 한하여 보유 및 이용됩니다. 다만, 관계 법령의 규정에 의하여 보존할 필요성이 있는 경우에는 관계 법령에 따라 보존합니다.
2. 관계 법령의 규정에 의하여 보존할 필요성이 있는 정보 및 보유기간은 아래와 같습니다.
    가. 요금의 정산, 요금 과오납 등 분쟁 발생 시 입증을 위하여 해지 후 개인정보(과금정보포함) : 해지일로부터 2년
    (단, 해지 고객이 이용대금을 납부하지 않았거나 고객과 요금관련 분쟁이 있는 때에는 해결시까지 보유)
    나. 통신비밀보호법 제15조의2 규정에 의하여 통신사실확인자료 제공 시 필요한 성명, 주민등록번호, 단말기번호 : 2년
    다. 국세기본법, 법인세법, 부가가치세법에 따른 성명, 주민등록번호, (해지)이동전화번호, 청구서 배달 주소, 요금 등 거래내역 관련 정보 : 2년
    라. 서비스의 불법적인 이용 등을 입증할 수 있는 개인정보 : 2년
    마. 개인위치정보 위치정보의 수집, 이용 또는 제공목적이 달성되면 즉시 폐기
    바. 위치정보 수집, 이용, 제공사실 확인자료 : 2년

`}
   <span className='sub'>개인정보보호를 위한 기술적 관리적 대책</span>{`

1. 기술적 대책
    (주)이케이시스는 고객의 개인정보를 취급함에 있어 개인정보가 분실, 도난, 누출, 변조 또는 훼손되지 않도록 안전성 확보를 위하여 아래와 같은 기술적 대책을 적용하고 있습니다.

    가. 고객의 개인정보는 외부망에서 접근 및 침입이 불가능한 내부망을 활용하여 관리되고 있으며, 파일 및 전송데이터를 암호화하거나 파일 잠금기능(Lock)을 사용하여 중요한 데이터는 별도의 보안 기능을 통해 철저하게 보호되고 있습니다.

    나. (주)이케이시스는 개인정보처리 시스템 및 개인정보취급자가 개인정보 처리에 이용하는 정보기기에 컴퓨터바이러스, 스파이웨어 등 악성 프로그램의 침투 여부를 항시 점검ㆍ처리할 수 있도록 백신프로그램을 설치하여 개인정보 침해를 방지하기 위한 조치를 취하고 있습니다. 또한, 백신프로그램은 주기적으로 업데이트되며 갑작스런 바이러스가 출현할 경우 백신이 나오는 즉시 이를 적용함으로써 개인정보가 침해되는 것을 방지하고 있습니다.

    다. (주)이케이시스는 암호알고리즘 등의 이용을 통하여 네트워크상에서 개인정보를 안전하게 전송할 수 있는 보안장치를 채택하고 있습니다.

    라. 해킹 등 외부침입에 대비하여 침입차단시스템 및 침입탐지시스템을 운영하여 사내 네트워크를 보호하고, 각 서버마다 접근제어시스템을 설치하여 보안을 강화하고 있습니다.


2. 관리적 대책

    가. (주)이케이시스는 개인정보의 안전한 보호를 위하여 주요 시스템 및 설비에 대하여 외부 전문기관으로부터 정보보호 관리체계 인증 등 객관적인 인증을 받아 운영되고 있습니다.

    나. (주)이케이시스는 고객의 개인정보에 대한 접근 및 관리에 필요한 절차 등을 마련하여 소속 직원으로 하여금 이를 숙지하고 준수하도록 하고 있습니다.

    다. (주)이케이시스는 고객의 개인정보를 취급할 수 있는 자를 최소한으로 제한하고 있습니다. 고객의 개인정보를 취급할 수 있는 자는 아래와 같습니다.

    ㅇ 고객을 직, 간접적으로 상대로 하여 마케팅 업무를 수행하는 자
    ㅇ 개인정보관리책임자 및 개인정보보호담당자 등 개인정보관리보호 업무를 수행하는 자
    ㅇ 기타 업무상 개인정보의 취급이 불가피한 자

    라. (주)이케이시스는 컴퓨터를 이용하여 고객의 개인정보를 처리하는 경우 개인정보에 대한 접근권한을 가진 담당자를 지정하여 식별부호(ID) 및 비밀번호를 부여하고, 해당 비밀번호를 정기적으로 갱신하고 있습니다.

    마. 개인정보를 취급하는 직원을 대상으로 새로운 보안기술 습득 및 개인정보보호 의무 등에 관해 정기적인 사내 교육 및 외부 위탁교육을 실시하고 있습니다.

    바. 신규직원 채용 시 정보보호서약서 또는 개인정보보호서약서에 서명함으로 직원에 의한 정보 유출을 사전에 방지하고 개인정보보호방침에 대한 이행사항 및 직원의 준수 여부를 감사하기 위한 내부절차를 마련하여 지속적으로 시행하고 있습니다.

    사. 직원의 퇴직 시 비밀유지서약서에 서명함으로 고객의 개인정보를 취급하였던 자가 직무상 알게 된 개인정보를 훼손, 침해 또는 누설하지 않도록 하고 있습니다.

    아. 개인정보 취급자의 업무 인수인계는 보안이 유지된 상태에서 철저하게 이뤄지고 있으며, 입사 및 퇴사 후 개인정보 침해사고에 대한 책임을 명확하게 규정하고 있습니다.

    자. 전산실 및 자료보관실 등을 특별 보호구역으로 설정하여 출입 통제 등 출입관리 절차를 시행하고 있습니다.

    차. 서비스이용계약체결 또는 서비스 제공을 위하여 고객의 신용카드번호, 은행 결제계좌 등 대금결제에 관한 정보를 수집하거나 고객에게 제공하는 경우 당해 고객이 본인임을 확인하기 위하여 필요한 조치를 취하고 있습니다.

`}
                <span className='sub'>개인정보보호를 위한 이용자 수칙</span>{`

1. 개인정보 제공은 필요한 경우에만 제공합니다.
2. 개인정보 제공 시 개인정보보호방침을 반드시 확인합니다.
3. 개인정보의 공개/비공개를 선택할 수 있는 경우 반드시 비공개를 선택합니다.
4. 블로그, 게시판 등에 자신 및 타인의 개인정보를 함부로 게재하지 않습니다.
5. 주기적으로 검색포털을 통해 자신의 이름, 주민번호, 핸드폰 번호 등을 검색하여 개인정보 노출 여부를 점검합니다.
6. 자신의 개인정보가 노출된 사실을 발견했을 경우 해당 웹사이트 또는 검색포털 사이트 등에 삭제 요청 등 적극적으로 조치를 요구합니다.
7. 타인의 주민등록번호를 부정 사용하여 회원가입 또는 서비스를 이용하지 않습니다.

`}
                <span className='sub'>개인정보 관련 업무의 위탁</span>{`

1. (주)이케이시스는 보다 나은 서비스 제공, 고객 편의 제공 등 원활한 업무 수행을 위해 타인에게 고객의 개인정보의 수집, 취급, 관리 등을 위탁하는 경우에는 반드시 사전에 이에 관한 사항을 고지합니다.

2. (주)이케이시스는 위탁업무계약서 등을 통하여 개인정보보호 관련 법규의 준수, 개인정보에 관한 비밀유지, 제 3자 제공에 대한 금지, 사고시의 책임부담, 위탁기간, 처리 종료 후의 개인정보의 반환 또는 파기 의무 등을 규정하고, 이를 준수하도록 관리하고 있습니다.

`}
                <span className='sub'>의견수렴 및 불만처리  </span>{`

1. (주)이케이시스는 고객의 의견을 매우 소중하게 생각합니다. 고객이 문의사항이 있을 경우 지점, 대리점을 방문하시거나 고객센터 등에 연락하여 문의하시면 신속, 정확한 답변을 드리겠습니다.

2. (주)이케이시스는 고객과의 원활한 의사소통을 위해 지점, 대리점, 고객센터 등 고객상담창구를 운영하고 있으며, 고객센터의 연락처는 다음과 같습니다.

ㅇ 전화번호 : 02)556-1737
ㅇ 전자우편 : biz@eksys.co.kr

`}
                <span className='sub'>개인정보관리책임자 및 담당자</span>{`

1. (주)이케이시스는 고객의 개인정보보호를 매우 중요시하며, 고객의 개인정보가 훼손, 침해 또는 누설되지 않도록 최선을 다하고 있습니다. 또한, 고객의 개인정보보호 관련 문의 시 지점, 대리점, 고객센터에서 신속하고 성실하게 답변을 드리도록 하고 있습니다. 고객이 (주)이케이시스의 개인정보보호 담당자와 연락을 원하실 경우 지점, 대리점, 고객센터에 메모를 남기시면 다른 업무에 우선하여 각 해당 부서의 개인정보보호 담당자와 연락을 취할 수 있도록 하고 있습니다.

[ 개인정보관리책임자 ]
성    명 : 황은석
소속부서 : GIS솔루션 사업부
직    위 : 이  사
전화번호 : 02)556-1764
이 메 일 : biz@eksys.co.kr

`}
                <span className='sub'>아동의 개인정보보호</span>{`

1. (주)이케이시스는 만 14세 미만 아동(이하 '아동')이 제공한 개인정보로 인하여 아동 및 법정대리인이 불이익을 입지 않도록 보호조치를 취하고 있습니다.

2. (주)이케이시스는 아동의 개인정보에 대하여 아래의 행위를 하는 경우에는 해당 아동의 법정대리인의 동의를 얻도록 하고 있습니다.
    가. 아동의 서비스 가입을 위한 개인정보를 수집하거나 서비스 가입 시 고지한 범위 또는 서비스 이용약관에 명시한 범위를 넘어 아동의 개인정보를 이용하거나 제 3자에게 제공하고자 하는 경우
    나. 아동의 개인정보를 제공받은 자가 개인정보를 제공받은 목적 외의 용도로 이용하거나 제 3자에게 제공하는 경우

3. (주)이케이시스는 법정대리인의 동의를 얻기 위하여 법정대리인의 성명, 연락처 등 필요한 최소한의 정보를 요구할 수 있습니다. 이 경우 개인정보의 수집, 이용 또는 제공목적 및 법정대리인의 동의가 필요하다는 취지를 아동이 쉽게 이해할 수 있는 평이한 표현으로 아동에게 고지합니다.

4. 법정대리인의 동의를 얻기 위하여 수집한 법정대리인의 개인정보를 해당 법정대리인의 동의 여부를 확인하는 목적 외의 용도로 이를 이용하거나 제 3자에게 제공하지 않습니다.

`}
                <span className='sub'>광고성 정보 전송</span>{`
                
1. (주)이케이시스는 고객의 사전 동의 없이 영리 목적의 광고성 정보를 전송하지 않습니다.

2. (주)이케이시스는 신상품이나 이벤트 정보안내 등 고객 지향적인 마케팅을 수행하기 위하여 광고성 정보를 전자우편으로 전송하는 경우에는 광고성 정보 전송에 대한 고객의 사전 동의를 득하고 전자우편의 제목란 및 본문란에 아래와 같이 고객이 광고성 정보임을 쉽게 알아볼 수 있도록 조치합니다.
    가. 전자우편의 제목란 : '(광고)'라는 문구를 제목란의 처음에 빈칸 없이 한글로 표시하고 이어서 전자우편 본문란의 주요 내용을 표시합니다.

3. 광고수신에 동의한 고객에게 팩스, 휴대폰 문자전송 등 전자우편 이외의 방법을 통해 영리 목적의 광고성 정보를 전송하는 경우에도 전송자의 명칭을 표기하는 등 필요한 조치를 취합니다.



개인정보처리방침
개인정보처리방침 시행일자 : 2022년 08월 01일
개인정보처리방침 버전번호 : V 2.0
                    `}
            </span>
        </div>
    )
}

export default Private
